import { SnapshotCollection } from "@/modules/snapshots/snapshotCollection.types";
import { BusinessReportOutcomeDetails } from "@/modules/snapshots/businessReports.types";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";

export const useSnapshotPermission = (obj: SnapshotCollection | BusinessReportOutcomeDetails) => {
  const user = useAuthenticatedUser();
  return obj.permissions.some(permission => permission.role === "owner" && permission.user_id === user.id);
};
